<template>
  <div class="wheel-battle-consumer-header">
    <div class="match-banner" @click="onMatchClick">
      <div class="match-banner-left">
        <img v-if="banner.icon" class="match-icon" :src="banner.icon" alt="" />
        <span class="match-name overflow-text">{{ banner.name }}</span>
        <van-icon name="arrow" color="#73767A" size="12" />
      </div>
      <div v-if="banner.groupStage" class="match-stage overflow-text">{{ banner.groupStage }}</div>
    </div>

    <div class="info-card">
      <img class="wheel-icon" :src="wheelBattleIconUrl" alt="" />
      <div class="info-main">
        <div class="info-title overflow-text">{{ header.name }}</div>
        <div v-if="header.groupLabel || parentStateLabel" class="tag-list">
          <span v-if="header.groupLabel" class="tag tag-group">{{ header.groupLabel }}</span>
          <span v-if="parentStateLabel" class="tag tag-status">{{ parentStateLabel }}</span>
        </div>
        <div v-if="header.beginDateText" class="info-meta">
          <van-icon name="clock-o" class="meta-icon" size="14" />
          <span class="meta-text">{{ header.beginDateText }}</span>
        </div>
        <div v-if="header.fieldName" class="info-meta">
          <van-icon name="location-o" class="meta-icon" size="14" />
          <span class="meta-text">{{ header.fieldName }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Icon } from 'vant'
Vue.use(Icon)

export default {
  name: 'WheelBattleConsumerHeader',
  props: {
    banner: {
      type: Object,
      default: function () {
        return {}
      }
    },
    header: {
      type: Object,
      default: function () {
        return {}
      }
    },
    unionMatchId: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      wheelBattleIconUrl: 'https://images.snsports.cn/Fmapyv1dN1-f7Mj4S5iVL2UwnMbb'
    }
  },
  computed: {
    parentStateLabel: function () {
      var header = this.header || {}
      if (header.parentStateName) {
        return header.parentStateName
      }
      var state = Number(header.state)
      if (state === 1) {
        return '进行中'
      }
      if (state === 2) {
        return '已结束'
      }
      if (state === 0) {
        return '未开始'
      }
      return ''
    }
  },
  methods: {
    onMatchClick: function () {
      if (!this.unionMatchId) {
        return
      }
      this.$router.push('/new-match-detail/' + this.unionMatchId + '/home')
    }
  }
}
</script>

<style scoped lang="scss">
.wheel-battle-consumer-header {
  background: linear-gradient(180deg, #e3eaf1 0%, #f8fbff 100%);
  padding: 16px 16px 20px;
  box-sizing: border-box;
}

.match-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 343px;
  max-width: 100%;
  height: 24px;
  margin: 0 auto;
  padding: 0 10px 0 6px;
  background: #c4cfde;
  border-radius: 61px;
  box-sizing: border-box;
}

.match-banner-left {
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1;
}

.match-banner-left > * + * {
  margin-left: 6px;
}

.match-icon {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  flex-shrink: 0;
  object-fit: cover;
}

.match-name {
  font-size: 12px;
  color: #73767a;
  line-height: 18px;
}

.match-stage {
  flex-shrink: 0;
  margin-left: 12px;
  max-width: 42%;
  font-size: 12px;
  color: #73767a;
  line-height: 18px;
  text-align: right;
}

.info-card {
  display: flex;
  align-items: center;
  margin-top: 16px;
}

.wheel-icon {
  margin-right: 14px;
  width: 66px;
  height: 66px;
  border-radius: 50%;
  flex-shrink: 0;
  display: block;
}

.info-main {
  flex: 1;
  min-width: 0;
}

.info-title {
  font-size: 18px;
  font-weight: 600;
  color: #1d2129;
  line-height: 26px;
}

.tag-list {
  display: inline-flex;
  flex-wrap: nowrap;
  margin-top: 8px;
  overflow: hidden;
  border-radius: 2px;
}

.tag {
  display: inline-block;
  padding: 2px 8px;
  font-size: 11px;
  line-height: 16px;
  border-radius: 0;
  white-space: nowrap;
}

.tag-group {
  color: #73767a;
  background: #c8e0f3;
}

.tag-status {
  color: #c45656;
  background: #fdeeee;
}

.info-meta {
  display: flex;
  align-items: center;
  margin-top: 8px;
  min-width: 0;
  color: #73767a;
}

.meta-icon {
  flex-shrink: 0;
  margin-right: 6px;
  color: #73767a;
}

.meta-text {
  font-size: 13px;
  line-height: 18px;
}

.overflow-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
